import React, { useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { compose } from 'redux'
import { getSessionsSaga } from './saga'
import injectSaga from '../../utils/injectSaga'
import { getSessions } from '../App/actions'

const SessionsLoader = () => {
  const dispatch    = useDispatch()
  const sessions    = useSelector(state => state.toJS().global.sessions)
  const agencytoken = useSelector(state => state.toJS().global.agencytoken)
  const isAdmin     = useSelector(state => state.toJS().global.isAdmin)

  useEffect(() => {
    if (!isAdmin && sessions == null && agencytoken != null) {
      dispatch(getSessions(agencytoken))
    }
  }, [sessions, agencytoken, isAdmin])

  return <div />
}

const withConnect = connect(null, null)
const withSaga = injectSaga({ key: 'SessionsLoader', saga: getSessionsSaga })
export default compose(withSaga, withConnect)(SessionsLoader)
